export default __webpack_public_path__ + "static/media/servAccount3.18bdd11f.png";